<script setup>
import SectionViewer from '../../components/SectionViewer.vue'

// Define sections
const sections = [
  { id: 'leyes', title: '2.1.1 Leyes' },
  { id: 'decreto-unico', title: '2.1.2 Decreto Único Reglamentario' },
  { id: 'normativa-aplicable', title: '2.1.3 Normativa aplicable' },
  { id: 'diario-oficial', title: '2.1.4 Vínculo al Diario o Gaceta Oficial' },
  { id: 'politicas-lineamientos', title: '2.1.5 Políticas, lineamientos y manuales' },
  { id: 'agenda-regulatoria', title: '2.1.6 Agenda Regulatoria' },
  { id: 'suin', title: '2.2.1 Sistema Único de Información Normativa – SUIN' },
  { id: 'sistema-busqueda', title: '2.2.2 Sistema de búsquedas de normas' },
  { id: 'proyectos-normativos', title: '2.3.1 Proyectos normativos' },
  { id: 'comentarios-respuesta', title: '2.3.2 Comentarios y documento de respuesta' },
  { id: 'participacion-sucop', title: '2.3.3 Participación ciudadana SUCOP' }
]
</script>

<template>
  <SectionViewer :sections="sections" title="2. Normativa" />
</template>
